// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"247":"222d782e","761":"e6e444a4"}[chunkId] + ".js";
};